import React from "react";
import clubLogo from './assets/club.png';
import sterlingLogo from './assets/sterling.png';
import './style.scss';

// 来源：https://m.lhw.cn/leaders-club/benefits-compare
// 保留官网移动版文案；注册、SIXT 及其他页面的跳转不迁入 H5。
const benefitGroups = [
  {
    title: '专享入住权益',
    footnote: '1',
    benefits: [
      { title: '入住时客房升级优先权' },
      { title: '每日双份免费欧陆早餐' },
      { title: '提前入住与延时退房服务\n（视酒店房况而定）' },
      { title: '免费上网' },
      { title: 'SXIT 会员匹配', values: ['SXIT金卡', 'SXIT铂金卡'], bold: true },
    ],
  },
  {
    title: '奖励回馈',
    footnote: '2',
    benefits: [
      {
        title: '入住前房型升级次数\n（每年）',
        values: [
          '会员 = 在会籍首年完成\n1次付费入住后可解锁入住前客房升级权益，每年享受1次',
          '每年5次入住前\n客房升级权益',
        ],
      },
      { title: '尊享贵宾会积分，可用于兑换\n免费房晚 1美金= 1个积分' },
      { title: '入住奖励积分', values: ['-', '5%'] },
    ],
  },
  {
    title: '会员专属优惠',
    benefits: [
      { title: '会员专享限时特惠' },
      { title: '最优房价' },
      { title: '会员专享体验' },
      { title: '新成员酒店专享体验' },
    ],
  },
];

export default function LHWBenefits() {
  return (
    <main>
      <h1 className="hotel-member-title">
        <img className="hotel-member-logo lhw-logo" src="https://staticfile.badazhou.com/20260922/3a9adf4953db45e06edbd708e91246ca.jpeg" alt="" />
        <span>立鼎世尊享贵宾会-会员礼遇</span>
      </h1>
      <div className="lhw-benefits">
        <h2>尊享贵宾会不同等级会员权益对比</h2>

        <table className="lhw-benefits__comparison" aria-label="">
          <thead>
            <tr>
              <td className="lhw-benefits__emblem"><img src={clubLogo} alt="" width="203" height="203" /></td>
              <td className="lhw-benefits__emblem"><img src={sterlingLogo} alt="" width="203" height="203" /></td>
            </tr>
            <tr>
              <th id="lhw-club" scope="col" className="lhw-benefits__tier">尊享贵宾会会员</th>
              <th id="lhw-sterling" scope="col" className="lhw-benefits__tier">尊享贵宾会银樽会员</th>
            </tr>
            <tr>
              <td className="lhw-benefits__value">会员权益价值约为500美金*</td>
              <td className="lhw-benefits__value">会员权益价值约为2000美金+</td>
            </tr>
          </thead>
          {benefitGroups.map((group, groupIndex) => (
            <tbody key={group.title}>
              <tr>
                <th colSpan="2" className="lhw-benefits__group">
                  {group.title}{group.footnote && <> <sup>{group.footnote}</sup></>}
                </th>
              </tr>
              {group.benefits.map((benefit, benefitIndex) => {
                const labelId = `lhw-benefit-${groupIndex}-${benefitIndex}`;
                return (
                  <React.Fragment key={benefit.title}>
                    <tr>
                      <th id={labelId} colSpan="2" className="lhw-benefits__label">{benefit.title}</th>
                    </tr>
                    <tr>
                      {['lhw-club', 'lhw-sterling'].map((tier, index) => (
                        <td key={tier} headers={`${tier} ${labelId}`} className="lhw-benefits__entitlement">
                          {!benefit.values ? (
                            <strong className="lhw-benefits__dot" aria-label="享有特权">&bull;</strong>
                          ) : benefit.bold ? (
                            <strong>{benefit.values[index]}</strong>
                          ) : (
                            <span className={benefit.values[index] === '-' ? 'lhw-benefits__dash' : undefined}>
                              {benefit.values[index]}
                            </span>
                          )}
                        </td>
                      ))}
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          ))}
        </table>

        <p className="lhw-benefits__legend"><strong>&bull;</strong><span>= 享有特权</span></p>

        <section id="lhw-benefit-details" className="lhw-benefits__details" aria-label="权益详情" tabIndex="-1">
          <p><strong className="lhw-benefits__terms">尊享贵宾会条件与条款适用。</strong></p>
          <p>* 基于12个月会籍期内最少完成2次入住，且每次入住为双人两晚入住的情况下，对会员权益价值平均值的估算。此价值为估算值，并不保证获得。</p>
          <p><sup>+</sup> 基于12个月会籍期内最少完成5次入住，且每次入住为双人两晚入住的情况下，对会员权益价值平均值的估算。此价值为估算值，并不保证获得。</p>
          <p><sup>&Dagger;</sup>为获得并保持银樽会员资格，您在一个自然年度（1月至12月）的客房房费消费需超过5000美金或其他等值货币。所有银樽会员权益在您取得该会员资格起生效，且保持至下一年度的12月31日，例如，您在2022年4月1日获得银樽会籍，该会籍资格将保持到2023年12月31日。</p>
          <p>
            <sup>1</sup> <b>入住礼遇:</b><br />
            尊享贵宾会会员入住礼遇仅限通过有效的预订渠道，使用对公众价格及尊享贵宾会会员专享价格完成的预订。如果您使用公司价格或协议价格完成预订及入住，可累积尊享贵宾会积分，但不可享受尊享贵宾会会员入住礼遇。
            <b>入住时客房升级优先权：</b>通过有效预订渠道完成的合规预订，入住时可享受客房升级优先权，有机会将预订的房型升至下一级。视成员酒店房况而定。
            <b>提早入住/延迟退房机会：</b>视成员酒店房况而定，需在办理入住手续时直接向酒店提出，进行安排。
          </p>
          <p>
            <sup>2</sup><b>会员计划回馈: </b><br />
            <b>入住前客房升级权益</b>将您预订的房型免费升至上一房型，但不适用于套房及套房以上房型。使用积分兑换预订不可享受入住前客房升级权益。成员酒店对客房类型及级别的规定有所不同，且视酒店房况而定。您必须在进行预订时提出入住前客房升级要求。如对已获得入住前升级确认的预订进行修改，升级状态也可能受到影响。
            <b>尊享贵宾会积分：</b>您在立鼎世成员酒店的有效入住，用于房费消费的每壹(1.00)美金或其它等值货币可获得壹(1)个尊享贵宾会积分。每个预订最多不超过叁(3)间客房。您的会籍必须保持有效，并在入住前与预订进行关联，才能赢取会员积分。
            <b>5%入住奖励积分：</b>贵为银樽会员，您在有效入住期间的客房房费消费1美金累积1分基础上，还可获得入住奖励积分。奖励积分按客房房费(不包含税费)的5%计算。奖励积分在您完成入住后约拾(10)天显示在您的尊尊享贵宾会账户。
          </p>
        </section>
      </div>
    </main>
  );
}
